<template>
  <page-view title>
    <!-- <exception-page type="norobot" v-if="!currentRobotId" /> -->
    <a-card :bordered="false" style="margin-top: 20px" >
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择查询条件" allowClear>
                  <a-select-option value="3">机器人子账户</a-select-option>
                  <a-select-option value="2">微信ID</a-select-option>
                  <a-select-option value="1">微信昵称</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询内容">
                <a-input v-model="queryParam.keywords" placeholder="请输入查询内容" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="分组">
                <a-select v-model="queryParam.group_id" placeholder="请选择分组" allowClear>
                  <template v-for="(item,index) in groupDataSource" >
                    <a-select-option :key="item.id" :value="item.id">{{ item.group_name }}</a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced"></template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button type="danger" style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
                <a-button @click="rRefresh" style="margin-left: 8px" >刷新</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div style="height: 60px;line-height: 60px;">
        <ActionsBoxVue ref="actions" show-type="box" @reload="$refs.table.refresh(true)"  @addMore="handleAddMore" />
      </div>
      <s-table ref="table" rowKey="sub_id"  :columns="columns" :data="loadData" :scroll="{ x: 1000 }">
        <span slot="index" slot-scope="text,record,index">
          {{index+1}}
        </span>
        <span slot="nickname" slot-scope="record">
          <span>{{
            record?record.nickname:'未知'
          }}</span>
        </span>
        <span slot="avatar" slot-scope="record">
          <a-avatar
            shape="square"
            :src="
              record
                ? record.avatar
                : '未知'
            "
          ></a-avatar>
        </span>
        <span slot="finished_count" slot-scope="record">{{record.finished_count}}</span>
        <span slot="unfinished_count" slot-scope="record">{{record.unfinished_count}}</span>
        <span slot="failed_count" slot-scope="record">{{record.failed_count}}</span>
        <span slot="status" slot-scope="record">
          <a-badge status="processing" v-if="record.status === -1" text="列表为空"></a-badge>
          <a-badge status="warning" v-else-if="record.status === 0" text="未发送"></a-badge>
          <a-badge status="warning" v-else-if="record.status === 1" text="开始执行"></a-badge>
          <a-badge status="error" v-else-if="record.status === 2" text="执行中"></a-badge>
          <a-badge status="success" v-else-if="record.status === 3" text="执行完成"></a-badge>
          <a-badge status="warning" v-else-if="record.status === 4" text="暂停执行"></a-badge>
        </span>
        <span slot="showList" slot-scope="record" @click="$refs.showTaskListModal.show(record.sub_id)">
          <a-button type="link" style="padding:0">
            点击查看
          </a-button>
        </span>
        <span slot="action" slot-scope="record" >
            <ActionsBoxVue ref="actions" :sub-id="record.sub_id" @reload="$refs.table.refresh(true)" @edit="handleAdd(record.sub_id)" />
        </span>
      </s-table>
      <div style="display:flex;justify-content:flex-end;">
        <a-button @click="prevPage" :disabled="pageNo<=1" type="link">上一页</a-button>
        <a-button @click="nextPage" :disabled="disNext" type="link">下一页</a-button>
      </div>
    </a-card>
    <show-task-list-modal ref="showTaskListModal"></show-task-list-modal>
    <add-task-modal ref="addTaskModal" @ok="handleRefresh"></add-task-modal>
    <edit-task-modal ref="editTaskModal" @ok="$refs.table.refresh()"></edit-task-modal>
    <group-send-modal ref="groupSendModal"></group-send-modal>
    <add-more-task-modal ref="addMoreTaskModal" @ok="handleRefresh" ></add-more-task-modal>
  </page-view>
</template>

<script>
import { STable, ExceptionPage } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import GroupApi from '@/api/group'
import { PageView } from '@/layouts'

import AddMoreTaskModal from './modules/AddMoreTaskModal'
import AddTaskModal from './modules/AddTaskModal'
import EditTaskModal from './modules/EditTaskModal'
import ShowTaskListModal from './modules/ShowTaskListModal.vue'
import GrouppushApi from '@/api/grouppush'
import { mapActions, mapGetters } from 'vuex'
import GroupSendModal from './modules/GroupSendModal'
import ActionsBoxVue from '@/views/grouppush/components/ActionsBox'
import DeviceGroupApi from '@/api/device-group'
export default {
  name: 'GrouppushTasklist',
  components: {
    ActionsBoxVue,
    PageView,
    STable,
    SearchRobot,
    ExceptionPage,
    AddTaskModal,
    EditTaskModal,
    GroupSendModal,
    ShowTaskListModal,
    AddMoreTaskModal
  },
  data() {
    return {
      groupDataSource:[],
      currentRobotId: '',
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      pageNo:1,
      disNext:false,
      // 表头
      columns: [
        {
          title: 'ID',
          width: '80px',
          scopedSlots: { customRender:'index' }
        },
        {
          title: '机器人ID',
          dataIndex: 'sub_id'
        },

        {
          title: '昵称',
          scopedSlots: { customRender: 'nickname' }
        },

        {
          title: '头像',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '发送状态',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '已发送',
          scopedSlots: { customRender: 'finished_count' }
        },
        {
          title: '未发送',
          scopedSlots: { customRender: 'unfinished_count' }
        },
        {
          title: '发送失败',
          scopedSlots: { customRender: 'failed_count' }
        },
        {
          title: '发送对象',
          scopedSlots: { customRender: 'showList' }
        },
        {
          title: '操作',
          width: '360px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: parameter => {
        return GrouppushApi.getRobotList(
          Object.assign(parameter,{pageNo:this.pageNo},this.queryParam)
        ).then(res=>{
          if(res.data.length==0){
            this.disNext=true
            this.$message.warning(res.msg)
            return 
          }else{
            this.disNext=false
          }
          return res
        })
      },
      count:0,
      finished_count:0,
      unfinished_count:0,
      failed_count:0,
      // 加载数据方法 必须为 Promise 对象
      currentChangeGroup: null
    }
  },
  filters: {
    broadcast_type(val) {
      if (val == 1) {
        return '全部微信好友'
      } else if (val == 2) {
        return '指定分组会员'
      }
    },
    message_type(val) {
      if (val == 1) {
        return '文本消息'
      } else if (val == 2) {
        return '图片消息'
      } else if (val == 3) {
        return '卡片消息'
      }
    }
  },
  created() {
    this.getGroupData()
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    },
    handleRefresh() {
      this.$refs.table.refresh()
      this.$refs.actions.getData()
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDelete() {},
    handleDeleteAll() {},
    handleEdit(group_id) {
      const robot_id = this.currentRobotId
      this.$refs.editModal.show({})
    },
    handleAddGroupUser(data) {
      const robot_id = this.currentRobotId
      this.currentChangeGroup = data
      this.$refs.selectFansModal.show({ robotid: robot_id })
    },
    onChangeFans(data) {
      this.$refs.selectFansModal.handleCancel()
      const wx_group_wx_id = this.currentChangeGroup.group_wx_id
      // let loading = this.$message.loading('正在操作');
      GroupApi.addGroupUser({
        sub_id: this.currentRobotId,
        wx_group_wx_id: wx_group_wx_id,
        wx_id: data.wxid,
        nickname: data.nickname,
        avatar: data.avatar,
        remark: ''
      })
        .then(res => {
          if (res.code === 1) {
            this.$message.success('操作成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          // this.$message.destroy(loading)
        })
    },
    handleAdd(id) {
      this.$refs.addTaskModal.show(id)
    },
    handleEdit(id) {
      this.$refs.editTaskModal.show(this.currentRobotId, id)
    },
    checkGroupSend(id) {
      this.$refs.groupSendModal.show(this.currentRobotId, id)
    },
    handleDelete(id) {
      const loading = this.$message.loading('正在删除')
      GrouppushApi.removeTask({ sub_id: this.currentRobotId, id: id })
        .then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    },
    handleUpdateStatus(id, status) {
      const loading = this.$message.loading('正在更新状态')
      GrouppushApi.updateTaskStatus({ sub_id: this.currentRobotId, id: id, status })
        .then(res => {
          if (res.code === 1) {
            this.$message.success('更新状态成功')
            this.$refs.table.refresh()
            this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
              robotid: this.currentRobotId,
              type: 'grouppushStatusUpdate',
              data: {
                id: id,
                status: status
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    },
    // 下一页
    nextPage(){
      this.pageNo++
      this.$refs.table.refresh()
    },
    // 上一页
    prevPage(){
      this.pageNo--
      this.$refs.table.refresh()
    },
    // 获取分组信息
    getGroupData() {
      DeviceGroupApi.getList(
        Object.assign({
          pageSize: 200,
        })
      ).then((res) => {
        this.groupDataSource = res.data
      })
    },
    // 刷新
    rRefresh(){
      this.queryParam = {}
      this.pageNo=1
      this.$refs.table.refresh(true)
    },
    // 批量设置内容
    handleAddMore(){
      this.$refs.addMoreTaskModal.show()
    }
  }
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
/deep/ .ant-card-body{
  position: relative;
}
.show_status_count{
  position: absolute;
  right: 30px;
  top:34px
}
</style>
